import React from "react";
import "../styles/NavigatorСodeTopBar.css";
import { useGame } from "../GameContext";
const TopBar: React.FC = () => {
  const { message, setHelpPanelOpen } = useGame();
  return (
      <div className="navigatorСode-top-bar">
        <a className="navigatorСode-logo" href="https://kotobot.app/index.html">
          <img
            className="navigatorСode-logo"
               title ="На главную"
            src="/img/kotobot.svg"
            alt="Kotobot logo"
          />
        </a>
        <div className="navigatorСode-message-bar">{message}</div>
        <img
          className="navigatorСode-icon"
          id = "navigatorСode-help-icon"
          alt="Помощь"
          src="/img/help-fix.svg"
          title="Помощь"
          onClick={() => setHelpPanelOpen(true)}
        />
      </div>
  );
};

export default TopBar;
